import React from "react";
import { Link } from "react-router-dom";

import { useLanguage } from "../i18n/LanguageContext";
import "./BuyPackageCta.css";

/**
 * The one way in to the Packages page.
 *
 * Used only where a visitor has just been shown something they need a package
 * to reach, so the wording and the destination stay identical in each of those
 * places without the button following them down the whole homepage.
 */
const BuyPackageCta = ({ className = "", label }) => {
  const { t } = useLanguage();

  return (
    <Link to="/packages" className={`btn btn-skew hpa-buy-cta ${className}`.trim()}>
      <span>{label || t("Buy Your Package")}</span>
    </Link>
  );
};

export default BuyPackageCta;
